import { makeAutoObservable } from 'mobx'

type IDropDown = {
  setOpen: (boolean: boolean) => void
  open: boolean
}

class DropDownStore {
  mapItems: Map<string, IDropDown>

  constructor() {
    makeAutoObservable(this)

    this.mapItems = new Map()
  }

  getItem = (id: string) => {
    return this.mapItems.get(id)
  }

  setItem = (id: string, value: IDropDown) => {
    this.mapItems.set(id, value)
  }

  deleteItem = (id: string) => {
    this.mapItems.delete(id)
  }

  allHide(dropdownId?: string, parentsId?: string[]) {
    Array.from(this.mapItems.keys()).forEach((id) => {
      if (dropdownId === id) return
      if (parentsId?.includes(id)) return

      const item = this.getItem(id)

      if (item?.open) {
        item.setOpen(false)
      }
    })
  }

  setOpen = (id: string, value: boolean) => {
    const item = this.getItem(id)

    if (item) {
      item.open = value

      this.setItem(id, item)
    }
  }

  hide(id: string) {
    this.setOpen(id, false)
  }
}

export const dropDownStore = new DropDownStore()
